import React from "react";
import ListView from "../../components/ContentDisplay/ListView";
import PageURLContextProvider from "../../contexts/pageURLContext";
import ControllerCard from "../Controllers/controllersTable/controllerCard";
import {TABLE_HEADERS} from "./inventory.constants";
import {useInventoryData} from "./useInventoryData";
import {useInventorySearchOptions} from "./useInventorySearchOptions";

const InventoryComponent = () => {
  const {searchOptions} = useInventorySearchOptions();
  const {handleSearch, inventories, paginationConfig, totalInventories} =
    useInventoryData();

  return (
    <div style={{marginTop: "10px"}}>
      <ListView
        listItems={inventories}
        listHeaders={TABLE_HEADERS}
        totalCount={totalInventories}
        withPagination={paginationConfig}
        withSearchQuery={true}
        searchPlaceHolder={"Filter Appliances"}
        searchOptions={searchOptions}
        handleSearch={handleSearch}
        cardContent={ControllerCard}
      />
    </div>
  );
};

const InventoryPage = () => {
  return (
    <PageURLContextProvider>
      <InventoryComponent />
    </PageURLContextProvider>
  );
};

export default InventoryPage;
